import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import helpersNumbers from "../../../helpers/numbers";
import TitleBar from "../../partials/content/TitleBar";
import allAdvertiseBannerUsers from "./ListAdvertise";

function AllAdvertise() {
  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }

    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const generateAllAdvertiseBannerUsers = () => {
    return (
      <div>
        <div className="alert alert-warning ">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                تبلیغات شما توسط طراحان و گرافیست های حرفه ای و با توجه به
                استراتژی , هدف و محتوا کمپین تبلیغاتی شما آماده و در زمان مناسب
                به نمایش در می آید.
              </p>
            </li>
            <li>
              <p className="text-justify">
                شما میتوانید از قسمت عملیات فایل های تبلیغات خود را در هفت
                اندازه دریافت کنید.
              </p>
            </li>
          </ul>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تبلیغ</td>
                <td>شماره کمپین</td>
                <td>نام کمپین</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ بروزرسانی</td>
                <td>آدرس فرود</td>
                <td>وضعیت</td>
                <td>بررسی</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAdvertiseBannerUsers.map((advertiseBannerUser, index) => {
                let classNameStateAdvertise = advertiseBannerUser.active
                  ? "success"
                  : "danger";
                let textStateAdvertise = advertiseBannerUser.active
                  ? "فعال"
                  : "غیر فعال";
                const [classNameConfirmAdvertise, textConfirmAdvertise] =
                  generateConfirmTag(advertiseBannerUser.confirm);

                return (
                  <tr key={index}>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(advertiseBannerUser.id)}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.campaign_id
                      )}
                    </td>

                    <td>{advertiseBannerUser.campaign_name}</td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.created_at
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.updated_at
                      )}
                    </td>
                    <td className=" text-center">
                      <a
                        className="btn btn-primary text-center"
                        target="_blank"
                        href={advertiseBannerUser.link}
                      >
                        <i className="fa fa-globe"></i>
                      </a>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameStateAdvertise} `}
                        >
                          {textStateAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameConfirmAdvertise}`}
                        >
                          {textConfirmAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/advertise/${advertiseBannerUser.id} `}
                            className="btn btn-info  "
                          >
                            <i className="fa fa-info"></i>
                          </Link>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="all-advertise-customer"
        activeItem="all-advertise-banner-customer"
      />

      <div className="content-wrapper">
        <TitleBar title="تبلیغات بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>{generateAllAdvertiseBannerUsers()}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllAdvertise;
